import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./order.css";
import ThemeSettings from "../../common/themeSettings/themeSettings";
import { baseUrl } from "../../../enum/constant";

const OrderExchange = ({
  fromUrl,
  crypto,
  amount,
  fiat,
  tabId,
  onLoginClick,
}) => {
  //

  const [cryptocurrencies, setCryptocurrencies] = useState([]);
  const [fiatCurrencies, setFiatCurrencies] = useState([]);
  const [selectedCrypto, setSelectedCrypto] = useState(null);
  const [selectedFiat, setSelectedFiat] = useState(null);
  const [cryptoAmount, setCryptoAmount] = useState("1");
  const [fiatAmount, setFiatAmount] = useState("1500");
  const [convertedAmount, setConvertedAmount] = useState("");
  const [loading, setLoading] = useState(true);
  const [loadingConversion, setLoadingConversion] = useState(false);
  const [error, setError] = useState("");
  const [isFiatToCrypto, setIsFiatToCrypto] = useState(false);
  const [isSetting, setIsSetting] = useState(false);

  const base = baseUrl;
  const cryptoApiUrl = base + "api/crypto-currencies";
  const fiatUrl = base + "api/fiat-currencies";
  const conversionUrl = base + "api/convert-crypto-to-fiat";
  const conversionUrlfiatTocripto = base + "api/convert-fiat-to-crypto";

  const fiatLogos = {
    USD: "/images/currency/usd_90681e5a82.svg",
    EUR: "/images/currency/eur_2fb3ea3cae.svg",
  };

  const allowedFiats = Object.keys(fiatLogos);
  const navigate = useNavigate();
  const location = useLocation(); // detects current route

  useEffect(() => {
    setIsSetting(false);
  }, [location.pathname]);

  useEffect(() => {
    fetchCryptocurrencies();
    fetchFiatCurrencies();
  }, []);

  useEffect(() => {
    const naviagetdCrypto = cryptocurrencies.find(
      (coin) => coin.symbol === crypto
    );
    if (crypto && naviagetdCrypto && fromUrl) {
      setSelectedCrypto(naviagetdCrypto);
    }
    const url = fiatCurrencies.find((f) => f.symbol === fiat);
    if (url && fromUrl && fiat) {
      setSelectedFiat(url);
    }
    window.scrollTo(0, 0);
  }, [crypto, fromUrl, fiat]);

  useEffect(() => {
    if (selectedCrypto && selectedFiat) {
      updateConvertedAmount();
    }
  }, [selectedCrypto, selectedFiat, cryptoAmount, fiatAmount, isFiatToCrypto]);

  const fetchCryptocurrencies = async () => {
    setLoading(true);
    setError("");
    try {
      const response = await axios.get(cryptoApiUrl);
      const coinsWithIds = response.data
        .filter((coin) => ["BTC", "USDT", "ETH", "USDC"].includes(coin.symbol)) // Filter by symbol
        .map((coin) => ({
          ...coin,
          id: coin.id, // Ensure each coin object has an 'id'
        }));
      setCryptocurrencies(coinsWithIds);

      const bitcoin = coinsWithIds.find((coin) => coin.symbol === "BTC");
      const naviagetdCrypto = coinsWithIds.find(
        (coin) => coin.symbol === crypto
      );

      if (crypto && naviagetdCrypto && fromUrl) {
        setSelectedCrypto(naviagetdCrypto);
      } else if (bitcoin) {
        setSelectedCrypto(bitcoin);
      }
    } catch (error) {
      setError("Error fetching cryptocurrencies. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const fetchFiatCurrencies = async () => {
    setLoading(true);
    try {
      const response = await axios.get(fiatUrl);
      const filteredFiats = response.data.filter((fiat) =>
        allowedFiats.includes(fiat.symbol)
      );

      const fiatOptionsWithIds = filteredFiats.map((fiat) => ({
        ...fiat,
        id: fiat.id, // Ensure each fiat object has an 'id'
        logo: fiatLogos[fiat.symbol],
      }));

      setFiatCurrencies(fiatOptionsWithIds);

      const usd = fiatOptionsWithIds.find((fiat) => fiat.symbol === "USD");
      const url = fiatOptionsWithIds.find((f) => f.symbol === fiat);
      if (url && fromUrl && fiat) {
        setSelectedFiat(url);
      } else if (usd) {
        setSelectedFiat(usd);
      } else {
        setSelectedFiat(fiatOptionsWithIds[0]);
      }
    } catch (error) {
      setError("Error fetching fiat currencies. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleCryptoChange = (selectedOption) => {
    setSelectedCrypto(selectedOption);
  };

  const handleFiatChange = (selectedOption) => {
    setSelectedFiat(selectedOption);
  };

  const handleAmountChange = (e) => {
    const amount = e.target.value;
    if (isFiatToCrypto) {
      setFiatAmount(amount);
    } else {
      setCryptoAmount(amount);
    }
  };

  const handleSwapClick = (id) => {
    if (id == 2 && isFiatToCrypto) {
      document.getElementById(tabId).classList.remove("show");
      setIsFiatToCrypto(false); // Toggle between fiat to crypto and crypto to fiat
      setTimeout(() => {
        document.getElementById(tabId).classList.add("show");
      }, 200);
    } else if (id == 1 && !isFiatToCrypto) {
      document.getElementById(tabId).classList.remove("show");
      setIsFiatToCrypto(true); // Toggle between fiat to crypto and crypto to fiat
      setTimeout(() => {
        document.getElementById(tabId).classList.add("show");
      }, 200);
    }
  };

  const handleOrderClick = () => {
    if (!selectedCrypto) return;
    const from = selectedCrypto.symbol;
    const amount = isFiatToCrypto ? fiatAmount : cryptoAmount; // Conditional amount based on the direction
    const to = selectedFiat.symbol;
    const amountType = isFiatToCrypto ? "fiat" : "crypto"; // You should pass a string that indicates the type (e.g., 'fiat' or 'crypto')
    const transactionType = isFiatToCrypto ? "Buy" : "Sell";
    // Pass the correct amountType in the URL string
    const transactionData = {
      from,
      amount,
      to,
      amountType,
      transactionType,
    };
    if (localStorage.getItem("token")) {
      navigate(`/dashboard`, {
        state: {
          from,
          amount,
          to,
          amountType,
          transactionType,
        },
      });
      if (location.pathname?.includes("dashboard")) {
        window.scrollTo(0, 0);
      }
    } else {
      localStorage.setItem(
        "pendingTransaction",
        JSON.stringify(transactionData)
      );
      onLoginClick();
    }
    // navigate(`/exchange/${from}/${amount}/${to}/${amountType}/${transactionType}`);
  };

  const updateConvertedAmount = async () => {
    setLoadingConversion(true);
    try {
      let response;
      if (isFiatToCrypto) {
        // Handle conversion from fiat to crypto
        response = await axios.post(conversionUrlfiatTocripto, {
          fiatSymbol: selectedFiat.symbol,
          cryptoSymbol: selectedCrypto.symbol,
          amount: fiatAmount,
        });

        if (response.data && response.data.convertedAmount) {
          const convertedCryptoAmount =
            response.data.convertedAmount.toFixed(6);
          setConvertedAmount(convertedCryptoAmount);
          setCryptoAmount(convertedCryptoAmount);
        } else {
          setError("Invalid response from server.");
        }
      } else {
        // Handle conversion from crypto to fiat
        response = await axios.post(conversionUrl, {
          cryptoSymbol: selectedCrypto.symbol,
          fiatSymbol: selectedFiat.symbol,
          amount: cryptoAmount,
        });

        if (response.data && response.data.convertedAmount) {
          setConvertedAmount(response.data.convertedAmount.toFixed(2));
        } else {
          setError("Invalid response from server.");
        }
      }
    } catch (error) {
      console.error("Conversion error:", error);
      setError("Error converting currency. Please try again later.");
    } finally {
      setLoadingConversion(false);
    }
  };

  const formatCryptoOptionLabel = ({ logo, symbol }) => (
    <div style={{ display: "flex", alignItems: "center" }}>
      <img
        src={logo}
        alt={`${symbol} logo`}
        style={{ width: "20px", height: "20px", marginRight: "8px" }}
      />
      <span>{symbol.toUpperCase()}</span>
    </div>
  );

  return (
    <>
      <div className="form-part">
        <Link to="#" onClick={() => setIsSetting(!isSetting)}>
          <div className="setting-ic">
            {!isSetting ? (
              <img src="assets/images/setting.png" />
            ) : (
              <img src="assets/images/cross.png" />
            )}
          </div>
        </Link>
        <div className="tab-part">
          <ul className="nav nav-tabs" id="myTab" role="tablist">
            <li className="nav-item">
              <a
                onClick={() => {
                  setIsSetting(false);
                  handleSwapClick(1);
                }}
                className="nav-link"
                id="home-tab"
                data-toggle="tab"
                href={`#${tabId}`}
                role="tab"
                aria-controls={tabId}
                aria-selected="true"
              >
                Buy
              </a>
            </li>
            <li className="nav-item">
              <a
                onClick={() => {
                  setIsSetting(false);
                  handleSwapClick(2);
                }}
                className="nav-link active"
                id="profile-tab"
                data-toggle="tab"
                href="#profile"
                role="tab"
                aria-controls="profile"
                aria-selected="false"
              >
                Sell
              </a>
            </li>
          </ul>
          {isSetting ? (
            <>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id={tabId}
                  role="tabpanel"
                  aria-labelledby="home-tab"
                >
                  <div className="crp-form p-4">
                    <ThemeSettings isShort={true} />
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="tab-content" id="myTabContent">
              <div
                className="tab-pane fade show active"
                id={tabId}
                role="tabpanel"
                aria-labelledby="home-tab"
              >
                <div className="crp-form">
                  <h3>{isFiatToCrypto ? "Buy" : "Sell"} crypto</h3>
                  <div className="fom-wrap">
                    {/* YOU SEND */}
                    <div className="fm-group">
                      <div className="field-bg">
                        <label>You Send</label>
                        <div className="cpt-f-w">
                          <input
                            type="number"
                            placeholder="0.0"
                            className="c-inpt"
                            value={isFiatToCrypto ? fiatAmount : cryptoAmount}
                            onChange={handleAmountChange}
                          />
                          <div className="sel-c">
                            <div className="dropdown sik-dropdown">
                              <button
                                className="btn btn-secondary dropdown-toggle"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                {isFiatToCrypto && selectedFiat ? (
                                  <>
                                    <img
                                      className="crypto-icon"
                                      src={selectedFiat.logo}
                                      alt={selectedFiat.symbol}
                                    />
                                    {selectedFiat.symbol}
                                  </>
                                ) : selectedCrypto ? (
                                  <>
                                    <img
                                      className="crypto-icon"
                                      src={selectedCrypto.logo}
                                      alt={selectedCrypto.symbol}
                                    />
                                    {selectedCrypto.symbol}
                                  </>
                                ) : (
                                  "Select"
                                )}
                              </button>
                              <ul className="dropdown-menu dropdown-menu-dark buysend">
                                {(isFiatToCrypto
                                  ? fiatCurrencies
                                  : cryptocurrencies
                                ).map((item) => (
                                  <li key={item.symbol}>
                                    <span
                                      className="dropdown-item"
                                      onClick={() =>
                                        isFiatToCrypto
                                          ? handleFiatChange(item)
                                          : handleCryptoChange(item)
                                      }
                                    >
                                      <img
                                        className="crypto-icon"
                                        src={item.logo}
                                        alt={item.symbol}
                                      />
                                      {item.symbol}
                                    </span>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="exchange-btn">
                      <Link to="#">
                        <img src="assets/images/exchange.png" />
                      </Link>
                    </div>
                    {/* YOU GET */}
                    <div className="fm-group">
                      <div className="field-bg">
                        <label>You Get</label>
                        <div className="cpt-f-w">
                          <input
                            type="number"
                            placeholder="0.0"
                            className="c-inpt"
                            value={
                              isFiatToCrypto ? cryptoAmount : convertedAmount
                            }
                            readOnly
                          />
                          <div className="sel-c">
                            <div className="dropdown sik-dropdown">
                              <button
                                className="btn btn-secondary dropdown-toggle"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              >
                                {isFiatToCrypto && selectedCrypto ? (
                                  <>
                                    <img
                                      className="crypto-icon"
                                      src={selectedCrypto.logo}
                                      alt={selectedCrypto.symbol}
                                    />
                                    {selectedCrypto.symbol}
                                  </>
                                ) : selectedFiat ? (
                                  <>
                                    <img
                                      className="crypto-icon"
                                      src={selectedFiat.logo}
                                      alt={selectedFiat.symbol}
                                    />
                                    {selectedFiat.symbol}
                                  </>
                                ) : (
                                  "Select"
                                )}
                              </button>
                              <ul className="dropdown-menu dropdown-menu-dark buyget">
                                {(isFiatToCrypto
                                  ? cryptocurrencies
                                  : fiatCurrencies
                                ).map((item) => (
                                  <li key={item.symbol}>
                                    <span
                                      className="dropdown-item"
                                      onClick={() =>
                                        isFiatToCrypto
                                          ? handleCryptoChange(item)
                                          : handleFiatChange(item)
                                      }
                                    >
                                      <img
                                        className="crypto-icon"
                                        src={item.logo}
                                        alt={item.symbol}
                                      />
                                      {item.symbol}
                                    </span>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="value">
                      {/* 1 ETH ≈ 1,663.2219 USD */}
                      {isFiatToCrypto ? fiatAmount : cryptoAmount}{" "}
                      {isFiatToCrypto
                        ? selectedFiat?.symbol.toUpperCase()
                        : selectedCrypto?.symbol.toUpperCase()}{" "}
                      ≈ {convertedAmount}{" "}
                      {isFiatToCrypto
                        ? selectedCrypto?.symbol.toUpperCase()
                        : selectedFiat?.symbol.toUpperCase()}
                    </div>
                    <div className="btn-part">
                      <a
                        className="btn buy-btn cus-btn-hover-affect"
                        onClick={handleOrderClick}
                      >
                        {isFiatToCrypto ? "Buy " : "Sell "}{" "}
                        {selectedCrypto?.symbol || ""}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default OrderExchange;
